import toast from 'react-hot-toast';
import { deleteGroupsInCompany } from '../../api/group-setting';
import { DeleteIcon } from '../icons/icons';
import GrayButton from '../submissions-database/GrayButton';
import DeleteGroupModal from './modals/DeleteGroupModal';
import { useState } from 'react';

function DeleteGroup({ groupId, onDeleteSuccess, groupName = '' }) {
  const [openDeleteGroupModal, setOpenDeleteGroupModal] = useState(false);
  const [loading, setLoading] = useState(false);

  const handleDeleteGroup = async () => {
    setLoading(true);
    try {
      const deleteGroupRes = await deleteGroupsInCompany(groupId);
      toast.success(deleteGroupRes?.data?.message || 'Group deleted successfully');
      onDeleteSuccess(groupId);
      setOpenDeleteGroupModal(false);
    } catch (e) {
      const { error = '', message = '' } = e?.response?.data || {};
      toast.error(error || message);
    } finally {
      setLoading(false);
    }
  };
  return (
    <>
      <GrayButton
        onClick={() => setOpenDeleteGroupModal(true)}
        className="!p-1"
        variant="ghost"
        icon={<DeleteIcon className="w-4" />}>
        <DeleteIcon />
      </GrayButton>
      <DeleteGroupModal
        groupName={groupName}
        open={openDeleteGroupModal}
        onClose={() => setOpenDeleteGroupModal(false)}
        handelDeleteGroupConfirm={handleDeleteGroup}
        loading={loading}
      />
    </>
  );
}

export default DeleteGroup;
